import { Pagination } from './pagination';
import { Transacao } from './transacao';
import { TransacaoUpdated } from './transacao-updated';

export class SearchResult {
   pagination: Pagination;
   transacoes: TransacaoUpdated[];

   constructor(transacoes?:Array<any>, pagination?:Pagination) {
        this.transacoes = transacoes;
        this.pagination = pagination;
    }   
}
